var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVerifiedFilled = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "currentcolor",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M7.492.433a.75.75 0 0 0-.984 0l-1.028.893-1.338-.259a.75.75 0 0 0-.85.492l-.446 1.287-1.287.445a.75.75 0 0 0-.492.851l.26 1.338-.894 1.028a.75.75 0 0 0 0 .984l.893 1.028-.259 1.338a.75.75 0 0 0 .492.85l1.287.446.445 1.287a.75.75 0 0 0 .851.491l1.338-.258 1.028.893a.75.75 0 0 0 .984 0l1.028-.893 1.338.258a.75.75 0 0 0 .85-.491l.446-1.287 1.287-.445a.75.75 0 0 0 .491-.851l-.258-1.338.893-1.028a.75.75 0 0 0 0-.984l-.893-1.028.258-1.338a.75.75 0 0 0-.491-.85l-1.287-.446-.445-1.287a.75.75 0 0 0-.851-.492l-1.338.26zM10.53 4.47a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06 0l-2-2a.75.75 0 0 1 1.06-1.06L6 7.94l3.47-3.47a.75.75 0 0 1 1.06 0",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgVerifiedFilled);
export default ForwardRef;